import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Profile = props => (
  <SvgIcon viewBox="0 0 18.711 18.71" {...props}>
    <g id="profile-user_1_" data-name="profile-user (1)" transform="translate(0 -0.001)">
      <path id="Path_2542" data-name="Path 2542" d="M9.355,0a9.355,9.355,0,1,0,9.355,9.355A9.356,9.356,0,0,0,9.355,0Zm0,2.8A3.094,3.094,0,1,1,6.261,5.893,3.095,3.095,0,0,1,9.355,2.8Zm0,13.467a6.866,6.866,0,0,1-4.471-1.649,1.319,1.319,0,0,1-.463-1,3.121,3.121,0,0,1,3.136-3.12h3.6a3.116,3.116,0,0,1,3.131,3.12,1.315,1.315,0,0,1-.462,1A6.864,6.864,0,0,1,9.353,16.265Z" />
    </g>
  </SvgIcon>
);

export default Profile;
